import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import HeroSection from './components/HeroSection';
import CategoryGrid from './components/CategoryGrid';
import AboutSection from './components/AboutSection';
import FeatureGrid from './components/FeatureGrid';
import TestimonialSection from './components/TestimonialSection';
import CTASection from './components/CTASection';
import FAQSection from './components/FAQSection';
import ArticlePreviews from './components/ArticlePreviews';
import { Link } from 'react-router-dom';
import { SITE_URL } from '@/constants';

export default function Home() {
  return (
    <div className="min-h-screen bg-background-50">
      <Navbar />

      <main>
        {/* Hero Section */}
        <HeroSection />

        {/* Category Grid */}
        <CategoryGrid />

        {/* About Section */}
        <AboutSection />

        {/* Feature Grid */}
        <FeatureGrid />

        {/* Testimonials */}
        <TestimonialSection />

        {/* Full CTA */}
        <CTASection />

        {/* FAQ */}
        <FAQSection />

        {/* Article Previews - 9 SEO Articles */}
        <ArticlePreviews />

        {/* Newsletter + Article Link */}
        <section className="py-16 md:py-20 bg-background-100">
          <div className="section-container">
            <div className="max-w-2xl mx-auto">
              {/* Article CTA */}
              <div className="bg-background-50 rounded-2xl p-8 md:p-10 mb-8 text-center border border-background-200/70">
                <div className="w-14 h-14 mx-auto mb-5 rounded-full bg-primary-100 flex items-center justify-center">
                  <i className="ri-article-line text-2xl text-primary-600"></i>
                </div>
                <h3 className="font-heading text-2xl md:text-3xl font-bold text-foreground-900 mb-3">
                  Sugargoo Spreadsheet Guide
                </h3>
                <p className="text-sm text-foreground-500 leading-relaxed mb-6 max-w-md mx-auto">
                  Learn everything about using the Sugargoo spreadsheet effectively — from finding the best products to understanding QC photos, shipping options, and safety tips.
                </p>
                <Link
                  to="/sugargoo-spreadsheet-guide"
                  className="inline-flex items-center gap-2 bg-primary-500 text-background-50 px-6 py-3 rounded-full text-sm font-semibold whitespace-nowrap hover:bg-primary-600 transition-colors cursor-pointer"
                >
                  Read Full Guide
                  <i className="ri-arrow-right-line"></i>
                </Link>
              </div>

              {/* Newsletter */}
              <div className="bg-foreground-900 rounded-2xl p-8 md:p-10 text-center">
                <h3 className="font-heading text-2xl md:text-3xl font-bold text-background-50 mb-3">
                  Stay Updated
                </h3>
                <p className="text-sm text-foreground-300 leading-relaxed mb-6 max-w-md mx-auto">
                  Get notified when new spreadsheet finds drop. No spam, just the best Sugargoo deals.
                </p>
                <form
                  data-readdy-form
                  id="newsletter-subscribe-form"
                  action="https://readdy.ai/api/form/d8pvgide8ise6dlc87r0"
                  method="POST"
                  className="flex flex-col sm:flex-row gap-3 max-w-md mx-auto"
                >
                  <input
                    type="email"
                    name="email"
                    placeholder="Enter your email"
                    required
                    className="flex-1 px-4 py-3 rounded-full text-sm bg-foreground-800 text-background-50 placeholder:text-foreground-400 border border-foreground-700 focus:outline-none focus:border-primary-500 transition-colors"
                  />
                  <button
                    type="submit"
                    className="bg-primary-500 text-background-50 px-6 py-3 rounded-full text-sm font-semibold whitespace-nowrap hover:bg-primary-600 transition-colors cursor-pointer"
                  >
                    Subscribe
                  </button>
                </form>
              </div>
            </div>
          </div>
        </section>
      </main>

      <Footer />

      {/* Organization Schema */}
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{
          __html: JSON.stringify({
            '@context': 'https://schema.org',
            '@type': 'Organization',
            '@id': `${SITE_URL}/#organization`,
            name: 'Sugargoo Spreadsheet Watch',
            url: SITE_URL,
            logo: {
              '@type': 'ImageObject',
              url: 'https://static.readdy.ai/image/2df560051ef0cafd8dabf8a049058ba4/1fc56da0b352904925ac780066826afe.jpeg',
            },
            sameAs: [
              'https://kaspreadsheet.com/',
            ],
            description: 'Your trusted resource for the latest Sugargoo spreadsheet finds with verified product links across sneakers, hoodies, jackets, bags, and accessories.',
          }),
        }}
      />

      {/* WebSite Schema */}
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{
          __html: JSON.stringify({
            '@context': 'https://schema.org',
            '@type': 'WebSite',
            '@id': `${SITE_URL}/#website`,
            name: 'Sugargoo Spreadsheet Watch',
            url: SITE_URL,
            description: 'Discover the best Sugargoo Spreadsheet 2026 with verified finds across sneakers, hoodies, jackets, bags, and accessories.',
            publisher: {
              '@type': 'Organization',
              '@id': `${SITE_URL}/#organization`,
              name: 'Sugargoo Spreadsheet Watch',
            },
            potentialAction: {
              '@type': 'SearchAction',
              target: `${SITE_URL}/search?q={search_term_string}`,
              'query-input': 'required name=search_term_string',
            },
          }),
        }}
      />
    </div>
  );
}